import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useLogout } from '@digiwedge/hooks-auth-web';
import { useGlobalStore, type GlobalState } from '@digiwedge/global-state';
import './AdminLayout.css';

const AdminLayout: React.FC = () => {
  const { logout, loading } = useLogout();
  const profile = useGlobalStore((s: GlobalState) => s.profile);

  return (
    <div className="admin-layout">
      <header className="admin-topbar">
        <div className="container admin-topbar-content">
          <Link to="/admin" className="admin-brand">
            YOLO Admin
          </Link>
          <nav className="admin-nav">
            <Link to="/admin" className="btn btn-outline">
              Command Deck
            </Link>
            <Link to="/admin/pricing" className="btn btn-outline">
              Pricing
            </Link>
            <Link to="/admin/content" className="btn btn-outline">
              Content
            </Link>
            {profile?.name ? <span className="text-sm">{profile.name}</span> : null}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => void logout()}
              disabled={loading}
            >
              Sign out
            </button>
          </nav>
        </div>
      </header>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
